module.exports = __webpack_public_path__ + "assets/img/checked2-af8a877a.png";